// extracted by mini-css-extract-plugin
export default {"melodyVideo":"FJ-z","isFullWidth":"GJ-z","landingPageVideo":"HJ-z","play":"IJ-z","iframeVideo":"JJ-z","playHidden":"KJ-z","fullwidth":"LJ-z"};